import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BaseModel} from "../depends/base.model";
import {ConfigurationService} from '../depends/configuration.service';
import {MatCheckboxChange} from "@angular/material";

export interface MultiSelectorEvent<T> {
    allSelected: boolean,
    selectedResources: T[]
}

@Component({
    selector: 'lib-multiple-resource-selector',
    templateUrl: './multiple-resource-selector.component.html',
    styleUrls: ['./multiple-resource-selector.component.css']
})
export class MultipleResourceSelectorComponent<T extends BaseModel> implements OnInit {

    @Input() set setResources(resources: T[]) {
        if (resources.length > 0) {
            this.resources = resources;
            this.initialSetup();
        }
    }

    @Input() displayField: string;
    @Input() secondDisplayField: string;

    @Output() onResourcesSelection: EventEmitter<MultiSelectorEvent<T>> = new EventEmitter<MultiSelectorEvent<T>>();

    resources: T[];
    selectedResources: T[];
    allResourcesSelected: boolean = false;

    constructor(
        private configurationService: ConfigurationService,
    ) {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
    }

    initialSetup() {
        this.selectedResources = this.resources;
        this.allResourcesSelected = true;
        this.onResourcesSelection.emit({
            allSelected: this.allResourcesSelected,
            selectedResources: this.selectedResources
        });
    }

    areAllResourcesSelected() {
        return this.allResourcesSelected;
    }

    getSelectedResources() {
        return this.selectedResources;
    }


    public toggleAllSelection(event: MatCheckboxChange) {
        if (event.checked) {
            this.selectedResources = [];
            for (let res of this.resources) {
                this.selectedResources.push(res);
            }
        } else
            this.selectedResources = [];
    }

    public setAllChecked() {
        this.allResourcesSelected = this.selectedResources.length >= this.resources.length;
    }


    public onSelectionClosed() {

    }


    _showResourceValue(resource: T){
        if (resource[this.displayField])
            return resource[this.displayField];

        if (this.secondDisplayField && resource[this.secondDisplayField])
            return resource[this.secondDisplayField];

        return ''
    }

}
